import * as React from 'react'
import { useSelector } from 'react-redux'
import { IOption, IProviderProps } from '@user/components/Filters'
import { selectAllSalesTeams } from '@user/store/salesTeam/slice'
import { useGetSalesTeamListForFilters } from '@user/store/salesTeam/hooks'
import { getSalesTeamOptionInputLabel } from '@user/components/Settings/SalesTeams/utils'

export const SalesTeamProvider: React.FC<IProviderProps> = ({ render }) => {
  const { isFetching } = useGetSalesTeamListForFilters()
  const salesTeams = useSelector(selectAllSalesTeams)

  const options: IOption[] = React.useMemo(
    () =>
      salesTeams.map((team) => ({
        value: team.id,
        label: getSalesTeamOptionInputLabel(team),
      })),
    [salesTeams],
  )

  return <>{render(options, isFetching)}</>
}
SalesTeamProvider.displayName = 'SalesTeamProvider'
